module.exports = __webpack_public_path__ + "static/WSC_Group_2018_Business_Check_List-45428a91e600894e88b5151a519815c0.pdf";